<template>
  <div id="LoadingComId" style="display:none;">
    <van-overlay :show="true">
      <van-loading
        color="red"
        size="30px"
        vertical
        style="margin-top:60%;color:red;"
        ><span style="color:red">加载中...</span></van-loading
      >
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: "LoadingCom",
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped>
.van-overlay {
  position: fixed;
  background-color: rgba(0, 0, 0, 0) !important;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/components/commonCom/LoadingCom.vue